export default "__VITE_ASSET__D1POo$F6__"